if (typeof window.__is_requirejs_config_loaded === "undefined")
{
    window.__is_requirejs_config_loaded = true;

    /*
     * jQuery가 여러번 로드되기 때문에-_-;; $(fn)으로 DOM-Ready 이벤트를 못잡는 경우가 있음.
     * window.addEventListener IE9 이상 지원
     */
    window.whenDomReady = function (cb) {
        if (document.readyState === "complete" || document.readyState === "interactive")
        {
            cb();
        }
        else
        {
            window.addEventListener('DOMContentLoaded', cb);
        }
    }

    var __isIe = (function () {
        var myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') !== -1) ? parseInt(myNav.split('msie')[1]) : false;
    })();

    require.config({
        "baseUrl": "",
        // cache buster(not activated for now)
        // "urlArgs"  : (window.location.hostname == "www.cconma.com") ? "" : "bust=" + (new Date()).getTime(),
        waitSeconds: 0, // waits indefinitely

        deps: (function () {
            // polyfill.js 가 1회만 로드 되도록
            var deps = [];
            // Promise auto polyfill to root
            if (typeof window.Promise !== "function")
            {
                deps.push("promise-auto");
            }
            return deps;
        })(),

        "paths": {
            "spinner"   : '//www.cconmausa.com/cdn/shop/t/3/assets/spinner.js?20210906&v=157739110172793952671713419215',
            "jquery-vue": '//www.cconmausa.com/cdn/shop/t/3/assets/jquery-vue.js?v=15726041048023564661620095023', // propagates DOM changes to Vue.js
            // "guid"      : '//www.cconmausa.com/cdn/shop/t/3/assets/guid.js?v=99495317194573780421620787721', // guid generator
            "clone-deep": '//www.cconmausa.com/cdn/shop/t/3/assets/clone-deep.js?v=106167941083256351211620787694', // Deep-clone JS object

            /*
             *========================================================
             *       ALL ***UNMODIFIED*** DEPENDENT LIBRARIES
             *                     | | | | | |
             *                     v v v v v v
             *========================================================
             */
            // JQUERY related
            //"jquery"               : (isIE() !== false && isIE() <= 8) ? "//code.jquery.com/jquery-1.12.4.min" : "/assets-v2/lib/jquery/3.2.1/jquery-retain.min", // 3.2.1
            "jquery"   : (__isIe !== false && __isIe <= 8) ? '//www.cconmausa.com/cdn/shop/t/3/assets/jquery-retain-1.12.4.min.js?v=5967636166318053771620787722' : '//www.cconmausa.com/cdn/shop/t/3/assets/jquery-retain-3.2.1.min.js?v=35060251074721723591620787722', // 3.2.1
            "jquery-ui": 'https://code.jquery.com/ui/1.12.1/jquery-ui.min',
            // Vue.js
            "vue": '//www.cconmausa.com/cdn/shop/t/3/assets/vue.min.js?v=76429315938595000261620787766',


            // Bootstrap 5
            "bootstrap5": '//www.cconmausa.com/cdn/shop/t/3/assets/bootstrap5.bundle.min.js?v=178806464053651140501627888244',

            // Bootstrap 3
            "bootstrap3": '//www.cconmausa.com/cdn/shop/t/3/assets/bootstrap3.4.1.js?v=134612481425155578491631696355',

            // @deprecated 모든 페이지에서 global scope에 polyfill 하므로 개별 dependency 불필요함
            "promise"     : '//www.cconmausa.com/cdn/shop/t/3/assets/promise-2.3.0.min.js?v=122462409206575953351620787766',
            "promise-auto": '//www.cconmausa.com/cdn/shop/t/3/assets/es6-promise.auto.min.js?v=23294462026546221611620095331',

            // datetime lib
            "moment"         : '//www.cconmausa.com/cdn/shop/t/3/assets/moment-with-locales.min.js?v=177831496896464848671620095357',
            "moment-timezone": '//www.cconmausa.com/cdn/shop/t/3/assets/moment-timezone-with-data.js?v=167153600814216015321620714308',

            "muuri"     : '//www.cconmausa.com/cdn/shop/t/3/assets/muuri.js?v=127153210819388136551620716325',
            "flexslider": '//www.cconmausa.com/cdn/shop/t/3/assets/jquery.flexslider.2.7.1.min.js?v=1749500410089166181620281526',
            "sortable"  : '//www.cconmausa.com/cdn/shop/t/3/assets/sortable.min.js?v=121392862638415310221627888246',
            //cms
            "cms-item-base"               : 'https://cus7.cconmausa.com/admin/dashboard/cms/substrate/item/item-base',
            "cms-snapshot-base"           : 'https://cus7.cconmausa.com/admin/dashboard/cms/substrate/section-snapshot/section-snapshot-base',
            "cms-snapshot-item-group-base": 'https://cus7.cconmausa.com/admin/dashboard/cms/substrate/item-group/item-group-base',
            "cms-template-render"         : 'https://cus7.cconmausa.com/assets/js/cms-render.js?' + Math.random(),
            "cms-youtube-lazy-auto-play"  : 'https://cus7.cconmausa.com/assets/cms/youtube-lazy-auto-play.js?' + Math.random(),
            "cms-cacheable-fetcher"       : '//www.cconmausa.com/cdn/shop/t/3/assets/cms-cacheable-fetcher.js?20220914&v=58518845475854411151749031048',

            "template-loader": '//www.cconmausa.com/cdn/shop/t/3/assets/template-loader.js?v=123116542038476535171620095386',
            "hammerjs"       : '//www.cconmausa.com/cdn/shop/t/3/assets/hammer-2.0.8.min.js?v=50904250349499066121620281448',
            "cconma-modal"   : '//www.cconmausa.com/cdn/shop/t/3/assets/cconma-modal.js?12&v=152525655545332228801712820868',

            "search-bar"   : '//www.cconmausa.com/cdn/shop/t/3/assets/search-bar.js?145713',
            "cc-search-bar": '//www.cconmausa.com/cdn/shop/t/3/assets/cc-search-bar.js?20210512&v=44761711402215758821676877578',
            "cc-add-cart"  : '//www.cconmausa.com/cdn/shop/t/3/assets/cc-add-cart.js?20210510&v=62186412330587376591713419214',
            "cc-notice"    : '//www.cconmausa.com/cdn/shop/t/3/assets/cc-notice.js?20220103&v=137281338707131988581641194162',
            "pagination"   : '//www.cconmausa.com/cdn/shop/t/3/assets/pagination.js?ss&v=68325340986976693591627888246',
            // "get-params": '//www.cconmausa.com/cdn/shop/t/3/assets/get-params.js?v=132809549298719603311620095335',

            "cc-order"         : '//www.cconmausa.com/cdn/shop/t/3/assets/cc-order.js?202206281124&v=17838126485819975781737501950',
            "cc-product-review": '//www.cconmausa.com/cdn/shop/t/3/assets/cc-product-review.js?2022111710&v=89263386203379314781720422377',

            "number-format": '//www.cconmausa.com/cdn/shop/t/3/assets/number-format.js?v=30342247026678929501636077369',
            // doT:one of the fastest JS template engine @see http://olado.github.io/doT/
            "doT"         : "//www.cconmausa.com/cdn/shop/t/3/assets/doT.min.js?v=19887191084407970291636002351",
            'vue-lazyload': '//www.cconmausa.com/cdn/shop/t/3/assets/vue-lazyload.js?v=14813053657585213421632722528',
            "progressbar" : '//www.cconmausa.com/cdn/shop/t/3/assets/progressbar.min.js?v=95088391610917011811652869736',
            "d2c-shipment-date"         : '//www.cconmausa.com/cdn/shop/t/3/assets/d2c-shipment-date.min.js?v=79901973011905116981755585848'
            //,"heic2any"  :   '//www.cconmausa.com/cdn/shop/t/3/assets/heic2any.js?v=108752117586756061281720086799'
        },
        map    : {
            "*": {
                "css": "//www.cconmausa.com/cdn/shop/t/3/assets/require-css.js?v=63862600969374659531627888252"
            }
        },
        "shim" : {
            "jquery"           : {exports: "$"},
            "jquery-ui"        : {deps: ["jquery"]},
            "bootstrap5"       : {deps: ["jquery", "css!//www.cconmausa.com/cdn/shop/t/3/assets/bootstrap5.min.css?v=29195500391666890861627888255"]},
            "bootstrap3"       : {deps: ["jquery", "css!//www.cconmausa.com/cdn/shop/t/3/assets/bootstrap3.4.1.min.css?v=107336412447542668051631696326"]},
            "cc-order"         : {deps: ["css!//www.cconmausa.com/cdn/shop/t/3/assets/cc-order.css?v=57042887642651512041720422378"]},
            "cc-product-review": {deps: ["css!//www.cconmausa.com/cdn/shop/t/3/assets/cc-product-review.css?v=75453690603950685621712308317"]},
            "cc-add-cart"      : {deps: ["css!//www.cconmausa.com/cdn/shop/t/3/assets/cc-add-cart.css?v=88449571838623669391713419217"]},
            "cc-notice"        : {deps: ["css!//www.cconmausa.com/cdn/shop/t/3/assets/cc-notice.css?20220103&v=139904269819807551301665477273"]},
            'flexslider'       : {deps: ["css!//www.cconmausa.com/cdn/shop/t/3/assets/flexslider.css?v=93686603115335537731620281512"]}
        }
    });

    /*
     * Chrome/Firefox/Edge만 지원. Safari,IE 미지원
     * Android 4.4.4 웹뷰 미지원. 삼성인터넷 지원.
     *
     * CANIUSE: https://caniuse.com/?search=requestidlecallback
     * shim source from https://gist.github.com/paullewis/55efe5d6f05434a96c36
     * API usage: https://developers.google.com/web/updates/2015/08/using-requestidlecallback
     *
     * 주의: polyfill.js 복사본임
     *
     */
    window.requestIdleCallback = window.requestIdleCallback || function (cb) {
        return setTimeout(function () {
            var start = Date.now();
            cb({
                didTimeout: false, timeRemaining: function () {
                    return Math.max(0, 50 - (Date.now() - start));
                }
            });
        }, 1);
    };

    window.cancelIdleCallback = window.cancelIdleCallback || function (id) {
        clearTimeout(id);
    };

    /*
     * requestIdleCallback 을 사용한 낮은 순위 require
     */
    window.requireIdle = function (deps, fn) {
        locallog("requireIdle started for deps:", deps);
        requestIdleCallback(function () {
            // locallog("requireIdle entered 1st requestIdleCallback, for deps:", deps);
            require(deps, function () {
                locallog("requireIdle resolved deps:", deps);
                var deps_resolved = arguments;
                if (typeof fn === "function")
                {
                    requestIdleCallback(function () {
                        locallog("requireIdle calling fn for deps:", deps);
                        fn.apply(null, deps_resolved);
                    });
                }
            });
        });
    };

    /*
     * ======================================================================
     *
     * 이하, 매우 자주 사용되는 일부 소형 모듈을 config 내부에 직접 정의했음.
     * 목적: 리퀘스트 수를 줄임
     * 참고: named module 정의시 define()의 signature는 아래와 같음
     *      define("module name", [ dependencies...], factory);
     *
     * ======================================================================
     *
     */

    /**
     * src: /JS/api-request.js
     * Ajax request Promise를 반환
     */
    define('api-request', ['jquery'], function ($) {
        function jQueryXhrToErrorMessage(xhr) {
            var resp = {};
            if (typeof xhr === "object")
            {
                if (xhr.status === 404)
                {
                    return "API 경로가 존재하지 않습니다(" + xhr.statusText + ")";
                }

                if (typeof xhr.responseJSON !== "undefined")
                {
                    resp = xhr.responseJSON;
                }
                else if (xhr.responseText)
                {
                    try
                    {
                        resp = JSON.parse(xhr.responseText)
                    }
                    catch (e)
                    {
                        resp = {};
                    }
                }
            }

            return resp.error ? resp.error : xhr.status + ' 오류가 발생했습니다';
        }

        var req = function (method, url, data, option) {
            return new Promise(function (resolve, reject) {
                var default_option = {
                    url : url,
                    type: method,
                    data: data,
                    //dataType: 지정하지 않아야 서버가 보내는 content-type을 jquery가 파악해 resolve에 전달
                    cache  : false,
                    success: resolve,
                    error  : function (xhr) {
                        reject(jQueryXhrToErrorMessage(xhr));
                    }
                };

                if (window.FormData && data instanceof FormData)
                {
                    default_option.contentType = false;
                    default_option.processData = false;
                }

                $.ajax($.extend(default_option, option || {}));
            });
        };

        function getToken() {
            return req("GET", "/pages/api-token")
                .then(function (response) {
                    return decodeURIComponent(response.trim());
                });
        }

        function reqWithToken(method, url, data, option) {
            return getToken()
                .then(function (token) {
                    data = data || {};
                    data.token = token;
                    return req(method, url, data, option);
                });
        }

        return {
            get          : function (url, data, option) {
                return req("GET", url, data, option);
            },
            getToken     : getToken,
            getWithToken : function (url, data, option) {
                return reqWithToken("GET", url, data, option);
            },
            post         : function (url, data, option) {
                return req("POST", url, data, option);
            },
            postWithToken: function (url, data, option) {
                return reqWithToken("POST", url, data, option);
            },
            put          : function (url, data, option) {
                return req("PUT", url, data, option);
            },
            putWithToken : function (url, data, option) {
                return reqWithToken("PUT", url, data, option);
            },
            // delete가 IE에서 키워드이기때문에
            del         : function (url, data, option) {
                return req("DELETE", url, data, option);
            },
            delWithToken: function (url, data, option) {
                return reqWithToken("DELETE", url, data, option);
            }
        };
    });

    /**
     * src: /JS/clone-deep.js
     */
    define('clone-deep', [], function () {

        /**
         * 딥 클론
         * - Object의 경우 new obj.constructor()로 새 인스턴스를 생성하므로, 컨스트럭터 파라메터 생략가능해야 함.
         *
         * @see https://stackoverflow.com/a/728694/760211
         * @param {*} obj
         * @param {Array} [excluded_constructor_names]
         */
        return function cloneDeep(obj, excluded_constructor_names) {
            excluded_constructor_names = excluded_constructor_names || [];

            var copy;

            // Handle the 3 simple types, and null or undefined
            if (null === obj || typeof obj === "undefined" || "object" !== typeof obj) return obj;

            // Handle Date
            if (obj instanceof Date)
            {
                copy = new Date();
                copy.setTime(obj.getTime());
                return copy;
            }

            // Handle Array
            if (obj instanceof Array)
            {
                copy = [];
                for (var i = 0, len = obj.length; i < len; i++)
                {
                    copy[i] = cloneDeep(obj[i], excluded_constructor_names);
                }
                return copy;
            }

            // Handle Object
            if (obj instanceof Object)
            {
                var constructor_name = obj.constructor.name;
                // IE에서 constructor.name 지원 안함. 대신 constructor가 function signature를 스트링으로 반환함.
                // constructor의 type은 function이고, toString을 지원하므로, function signature에서 constructor name을 읽음.
                if (typeof constructor_name === "undefined" && typeof obj.constructor === "function" && obj.constructor.toString)
                {
                    var const_name_temp = obj.constructor.toString().match(/function\s+(\w+)\(/);
                    if (const_name_temp !== null)
                    {
                        constructor_name = const_name_temp[1];
                    }
                }
                if (excluded_constructor_names.indexOf(constructor_name) > -1)
                {
                    return undefined;
                }

                copy = new obj.constructor(); // {}
                for (var attr in obj)
                {
                    if (obj.hasOwnProperty(attr))
                    {
                        // 언더바로 시작하는 프라퍼티는 프라이빗으로 취급, 복사 안함.
                        if (attr.substr(0, 1) === "_")
                        {
                            continue;
                        }
                        copy[attr] = cloneDeep(obj[attr], excluded_constructor_names);
                    }
                }
                return copy;
            }

            throw new Error("Unable to copy obj! Its type isn't supported.");
        }
    });

    define('get-params', ['clone-deep'], function (cloneDeep) {

        /**
         *
         * @param {string} [search] default: window.location.search
         * @returns 
         */
        function searchStringToObj(search) {
            var kvp = {};
            search = (typeof search === "string") ? search : window.location.search;
            search = search.replace(/^\?/, ''); // ? 제거
            search.split("&")
                .forEach(function (part) {
                    if (!part) return;

                    part = part.split("+").join(" "); // replace every + with space
                    var key = part, val = "";
                    var eq = part.indexOf("=");
                    if (eq > -1)
                    {
                        key = part.substr(0, eq);
                        val = part.substr(eq + 1);
                    }

                    key = decodeURIComponent(key);
                    val = decodeURIComponent(val);

                    kvp[key] = val;
                });
            return kvp;
        }

        /**
         *
         * @param {object} kvp
         * @param {boolean} [encode_uri] default:true
         * @returns {string}
         */
        function objToSearchString(kvp, encode_uri) {
            encode_uri = (typeof encode_uri === "undefined") ? true : encode_uri;

            var search = [];
            for (var key in kvp)
            {
                if (!kvp.hasOwnProperty(key)) continue;

                if (encode_uri)
                {
                    search.push(encodeURIComponent(key) + "=" + encodeURIComponent(kvp[key]));
                }
                else
                {
                    search.push(key + "=" + kvp[key]);
                }
            }

            return search.join("&");
        }

        /**
         *
         * @param {string|object} [search]
         */
        function GetParams(search) {

            // 참고: search 처리는 맨 하단에서

            var kvp = {};

            this.get = function (key) {
                return kvp[key];
            }

            this.set = function (key, value) {
                if (typeof value === "string" && value.match(/^(0|[1-9]\d*)$/))
                {
                    value = parseInt(value);
                }

                kvp[key] = value;
                return this;
            };

            this.unset = function (key) {
                delete kvp[key];
                return this;
            }

            this.merge = function (obj) {
                if (obj instanceof GetParams)
                {
                    obj = obj.export();
                }

                for (var key in obj)
                {
                    if (!obj.hasOwnProperty(key)) continue;

                    this.set(key, obj[key]);
                }

                return this;
            }

            /**
             * 모든 키에 prefix 추가
             * @param {string} prefix
             */
            this.addPrefix = function (prefix) {
                for (var key in kvp)
                {
                    if (!kvp.hasOwnProperty(key))
                    {
                        continue;
                    }

                    kvp[prefix + key] = kvp[key];
                    this.unset(key);
                }

                return this;
            }

            /**
             * 모든 키에서 prefix 제거
             * @param prefix
             * @returns {GetParams}
             */
            this.removePrefix = function (prefix) {
                for (var key in kvp)
                {
                    if (!kvp.hasOwnProperty(key))
                    {
                        continue;
                    }

                    if (key.indexOf(prefix) !== 0) continue;

                    // key 에서 prefix 제거
                    var new_key = key.substr(prefix.length);

                    kvp[new_key] = kvp[key];
                    delete kvp[key];
                }

                return this;
            }

            /**
             * fn(key) 에 false 반환하는 키를 삭제
             * @param {function} fn
             * @returns {GetParams}
             */
            this.filterKey = function (fn) {
                for (var key in kvp)
                {
                    if (!kvp.hasOwnProperty(key)) continue;
                    if (!fn(key))
                    {
                        this.unset(key);
                    }
                }

                return this;
            };

            /**
             * prefix 로 시작하는 키만 남김
             * @param {string} prefix
             * @returns {GetParams}
             */
            this.keysWithPrefix = function (prefix) {
                return this.filterKey(function (key) {
                    return key.indexOf(prefix) === 0;
                });
            };

            /**
             * prefix 로 시작하지 않는 키만 남김
             * @param {string} prefix
             * @returns {GetParams}
             */
            this.keysWithoutPrefix = function (prefix) {
                return this.filterKey(function (key) {
                    return key.indexOf(prefix) !== 0;
                });
            };

            /**
             *
             * @returns 
             */
            this.export = function () {
                return kvp;
            }

            /**
             *
             * @returns 
             */
            this.exportNotEmpty = function () {
                var non_empty_kvp = {};
                for (var key in this.export())
                {
                    if (!kvp.hasOwnProperty(key)) continue;
                    if (kvp[key] !== "" && typeof kvp[key] !== 'undefined')
                    {
                        non_empty_kvp[key] = kvp[key];
                    }
                }

                return non_empty_kvp;
            }

            /**
             *
             * @returns {string}
             * @param {boolean} [encode_uri] default:true
             */
            this.exportSearch = function (encode_uri) {
                encode_uri = (typeof encode_uri === "undefined") ? true : encode_uri;

                return objToSearchString(this.export(), encode_uri);
            }

            /**
             *
             * @returns {string}
             * @param {boolean} [encode_uri] default:true
             */
            this.exportSearchNotEmpty = function (encode_uri) {
                encode_uri = (typeof encode_uri === "undefined") ? true : encode_uri;

                return objToSearchString(this.exportNotEmpty(), encode_uri);
            }

            /**
             *
             * @param {string} [title]
             * @param  [data]
             * @param {boolean} [encode_uri] default:true
             */
            this.replaceHistory = function (title, data, encode_uri) {
                encode_uri = (typeof encode_uri === "undefined") ? true : encode_uri;

                if (typeof window.history === "object" && typeof window.history.replaceState === "function")
                {
                    if (typeof title !== "string")
                    {
                        title = "";
                    }

                    window.history.replaceState(data, title, "?" + this.exportSearchNotEmpty(encode_uri));
                }
            }

            search = (typeof search === "object") ? cloneDeep(search) : searchStringToObj(search);
            this.merge(search);
        }

        return GetParams;
    });

    define('guid', [], function () {
        //GUiD 생성

        if ((typeof window.crypto !== 'undefined') && (typeof window.crypto.getRandomValues !== 'undefined'))
        {
            return function () {
                var buf = new Uint16Array(8);
                window.crypto.getRandomValues(buf);
                var S4 = function (num) {
                    var ret = num.toString(16);
                    while (ret.length < 4)
                    {
                        ret = "0" + ret;
                    }
                    return ret;
                };

                return (S4(buf[0]) + S4(buf[1]) + "-"
                    + S4(buf[2]) + "-" + S4(buf[3]) + "-"
                    + S4(buf[4]) + "-" + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
            }
        }

        return function () { // Otherwise, just use Math.random
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                .replace(
                    /[xy]/g,
                    function (c) {
                        var r = Math.random() * 16 | 0,
                            v = (c === 'x') ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    }
                );
        }
    });
}
